import { featureOn } from "@lib/featureFlipper";

import { clientOriginHeader } from "../constants";
import type { ClientOrigin } from "../types";

/**
 * Returns the header identifying the dashboard client that sent a request, or no headers when
 * the dashboard_client_origin_header feature flipper is off.
 */
export const getClientOriginHeaders = (clientOrigin: ClientOrigin = "react"): Record<string, string> => {
  if (!featureOn("dashboard_client_origin_header")) {
    return {};
  }
  return { [clientOriginHeader]: clientOrigin };
};
